import { UserService } from 'src/app/services/user.service';
import { DeviceService } from './services/device.service';
import { Component, OnInit } from '@angular/core';

import { NavController, Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { Router } from '@angular/router';
import { Storage } from '@ionic/storage';
import { AuthenticationService } from './services/authentication.service';

import * as moment from 'moment';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {

    public storageUserInfo: any = {};
    public isCatalogues = false;
    public isReports = false;
    public isStaff = false;
    public isBenefits = false;
    public selectedIndex = 0;
    public appPages = [
        // {
        //     title: 'Mis beneficios',
        //     url: '/benefits/index',
        //     icon: 'star'
        // },
        {
            title: 'Mi tarjeta digital',
            url: '/my-digital-card',
            icon: 'card'
        },
        {
            title: 'Mis Entradas',
            url: '/index',
            icon: 'time'
        },
        {
            title: 'Reportes',
            url: '/reports',
            icon: 'newspaper'
        },
    ];
    public labels = ['Cerrar sesisón'];

    constructor(
        private platform: Platform,
        private splashScreen: SplashScreen,
        private statusBar: StatusBar,
        private router: Router,
        private authService: AuthenticationService,
        private storage: Storage,
        public deviceService: DeviceService,
        private navCtrl: NavController,
        public userService: UserService
    ) {
        this.initializeApp();
        moment.locale('es');
    }

    initializeApp() {
        this.platform.ready().then(() => {
            this.statusBar.styleDefault();
            this.splashScreen.hide();
            this.authService.authState.subscribe(state => {
                console.log('state: ', state);
                if (state === true) {
                    this.getUserInfo();
                } else {
                    if (state === false) {
                        console.log('primero pasa al login');
                        this.navCtrl.navigateRoot('login');
                        this.splashScreen.hide();
                    }
                }
            })
        });
    }

    ngOnInit() {
        /*const path = window.location.pathname.split('folder/')[1];
        if (path !== undefined) {
          this.selectedIndex = this.appPages.findIndex(page => page.title.toLowerCase() === path.toLowerCase());
        }*/

    }

    async getUserInfo() {
        this.storage.get('USER_INFO').then((user: any) => {
            if (user) {
                this.deviceService.isLoggedIn = true;
                console.log('user_token', user);
                this.storageUserInfo = user;
                const noRedirectPaths = [
                    '/create-report',
                    '/edit-report',
                    '/duplicates-review',
                    '/reports',
                    '/staff-report',
                    '/agenda',
                ];
                if (!noRedirectPaths.some(p => window.location.pathname.startsWith(p))) {
                    this.navCtrl.navigateRoot('index');
                }
                this.splashScreen.hide();
                this.userInfo();
            }
        });
    }

    get isSuperAdmin(): boolean {
        return this.userService?.user?.rol === 'superadmin';
    }

    goTo(route) {
        this.router.navigateByUrl(route);
    }

    logout() {
        console.log('logout');
        this.authService.logout();
    }

    userInfo() {
        this.storage.get('user').then((user) => {
            if (user) {
                this.userService.user = user;
            }
        });
        this.userService.getUser().subscribe((response: any) => {
            if (response) {
                this.userService.user = { ...(this.userService.user || {}), ...response };
            }
        }, err => {});
    }

    //[class.selected]="selectedIndex == i"
}
